var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExamManagementIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50905 3.5H7.61926V5.52518C7.61926 6.5791 8.47782 7.43765 9.53174 7.43765H14.4683C15.5222 7.43765 16.3808 6.5791 16.3808 5.52518V3.5H18.491C19.2712 3.5 19.9091 4.13816 19.9091 4.91811V20.0816C19.9091 20.8618 19.2712 21.5 18.491 21.5H5.50905C4.72883 21.5 4.09094 20.8618 4.09094 20.0816V4.91811C4.09094 4.13816 4.72883 3.5 5.50905 3.5ZM8.65906 3.5H15.3407V5.52518C15.3407 6.00525 14.948 6.39788 14.468 6.39788H9.53143C9.05136 6.39788 8.65872 6.00525 8.65872 5.52518L8.65906 3.5ZM6.22855 17.528H17.8023V18.9041H6.22855V17.528ZM6.22855 13.9264H17.8023V15.3022H6.22855V13.9264ZM8.45441 10.3249H15.5763V11.7006H8.45441V10.3249Z",
    fill: "#262626"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamManagementIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exam_management_icon.92d7ccbd.svg";
export { ForwardRef as ReactComponent };